@if (visible) {
  <div class="error-banner" role="alert">
    <p class="error-banner__message">
      Something went wrong. Please try again or call us at
      <a [href]="phoneHref" class="error-banner__phone">{{ phoneDisplay }}</a>.
    </p>
    <button class="error-banner__dismiss" (click)="dismiss()" aria-label="Dismiss error">&#x2715;</button>
  </div>
}
